export default {
  firstName: '',
  lastName: '',
  displayName: '',
  email: '',
  role: '',
  password: '',
  confirm: '',
};
